module.exports = __webpack_public_path__ + "img/Vector.6f886646.svg";